<template>
  <div
    :class="['sac-checkbox-container', disable ? 'disabled' : null,]"
    @click="handleChange(field)"
    @keydown="handleChange(field)"
  >
    <div
      :class="[
        'sac-checkbox',
        disable ? 'disabled' : null,
        checked ? 'active' : null,
      ]"
      :style="{
        backgroundColor: checked
          ? activeCheckboxColor
            ? activeCheckboxColor : '#2759E4' : '',
      }"
    >
      <span
        :class="[
          'checkbox',
          checked ? 'active' : '',
        ]"
      />
    </div>
    <div
      :class="[
        textColor === 'white' ? 'text-white' : '',
        'label',
      ]"
    >
      {{ capitalize(label) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SACCheckbox',
  props: {
    checked: Boolean,
    change: Function,
    field: String,
    label: String,
    textColor: String,
    disable: Boolean,
    activeCheckboxColor: String,
  },
  methods: {
    capitalize(value) {
      if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
      return '';
    },
    handleChange(field) {
      if (!this.disable) {
        this.change(field);
      }
    },
  },
};
</script>

<style lang="scss">

.sac-checkbox-container {
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  gap: 1rem;
  align-items: center;
  cursor: pointer;
  &.disabled {
    cursor: not-allowed;
  }
  &:hover {
    opacity: 0.8;
  }
  .sac-checkbox {
    position: relative;
    cursor: pointer;
    height: 26px;
    width: 26px;
    border-radius: 5px;
    background-color: $NBLUE10;
    &:hover {
      background-color: $NBLUE20;
    }
    &.disabled {
      cursor: not-allowed;
      background-color: $N30 !important;
    }
    .checkbox {
      position: absolute;
      top: 0;
      left: 0;
      &.active {
        left: 9px;
        top: 2px;
        width: 8px;
        height: 16px;
        border: solid $WHITE;
        border-width: 0 3px 3px 0;
        transform: rotate(45deg);
      }
    }
  }
  .label {
    white-space: nowrap;
  }
  .text-white {
    color: $NBLUE20;
  }
}

</style>
